__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalSettings";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(6486))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(216), __webpack_require__.e(601)]).then(() => (() => (__webpack_require__(8216))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(197), __webpack_require__.e(410)]).then(() => (() => (__webpack_require__(197))))));
			register("react", "18.2.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(4791))))));
			initExternal(4403);
			initExternal(2038);
			initExternal(7219);
			initExternal(3126);
			initExternal(5634);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};